 "use strict";

import {clone, memoize} from 'underscore';
var React = require('react/addons');
var Constants = require('ofs/apps/core/constants');
var Fluxxor = require('fluxxor');

var $ = require('jquery');

var SimilarHomesStore = Fluxxor.createStore({
  actions: {
    SIMILAR_HOMES_LOAD: 'loadHomes',
    SIMILAR_HOMES_UPDATE: 'updateHomes'
  },

  memoizedAjax: memoize($.ajax, JSON.stringify),

  initialize: function (options) {
    this.setMaxListeners(0);
    this.state = clone(options);
    this.state.loaded = false;
    this.state.homes = [];
  },

  updateHomes: function(payload) {
    var json = payload.json;

    this.state = React.addons.update(this.state, {
      homes: {$set: json.units},
      loaded: {$set: true}
    });
    this.emit('change');
  },

  loadHomes: function() {
    // Memoizing the request factory to workaround behaviour of "HomesList.jsx"
    // which calls `loadHomes` on mount (fires on resize). Eventually will move
    // "loadHomes" call out mount but not yet because 3 legacy components also
    // use "HomesList.jsx". To fix once the legacy components are deleted.
    this.memoizedAjax({
      type: 'GET',
      dataType: 'json',
      url: this.state.url,
      cache: false,
      success: this.flux.actions.similarHomes.update
    });
  },

  getState: function () {
    return this.state;
  }
});

module.exports = SimilarHomesStore;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/homes/detail/stores/similar-homes.js
 **/